/**
 * Seat-rotation helpers for the online table — a fork-specific replacement
 * for src/game/seatUtils.js's `isLocalPlayer`/`LOCAL_PLAYER_INDEX = 0`.
 * Offline always seats the human at index 0; online, "my" real seat (as
 * assigned by the backend, `GAME_STATE_SYNC.payload.seat`) can be 0-3, but
 * the table should still always render *my* cards at the bottom (visual
 * slot 0), same as offline. Every position lookup in OnlineTableRenderer
 * goes through a visual slot first.
 */

export function toVisualSlot(actualSeat, mySeat) {
    return (actualSeat - mySeat + 4) % 4;
}

export function toActualSeat(visualSlot, mySeat) {
    return (visualSlot + mySeat) % 4;
}

/**
 * Real dealing order for a hand: dealer+1 first, dealer last — same rule as
 * the offline engine's DealManager.getDealingOrder (src/game/DealManager.js),
 * duplicated here (4-line helper) so the online renderer doesn't need to
 * import the offline DealManager class just for this.
 */
export function getDealingOrder(dealerIndex) {
    const order = [];
    for (let i = 1; i <= 4; i++) order.push((dealerIndex + i) % 4);
    return order;
}
